// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-eafb8c04].select-reason,[data-v-eafb8c04].notes-input {\n  padding: 0 !important;\n}\n[data-v-eafb8c04].table thead th {\n  background-color: white !important;\n  text-transform: capitalize;\n  color: #181818;\n  letter-spacing: 0;\n  font-size: 0.75rem;\n  padding: 8px;\n}\n[data-v-eafb8c04].table-responsive {\n  overflow-x: initial;\n}\n", ""]);
// Exports
module.exports = exports;
